'use client';
import { ChakraProvider } from '@chakra-ui/react';
import { theme } from 'app/theme';

export const ThemeProvider = ({ children }) => (
  <ChakraProvider theme={theme}>{children}</ChakraProvider>
);
